export enum SurveyStatusStateEnum {
  IS_CREATING = 'isCreating',
  IS_UPDATING = 'isUpdating',
  IS_DELETING = 'isDeleting',
  IS_GETTING = 'isGetting',
  IS_DISTRIBUTING = 'isDistributing',
  ERROR = 'error',
  SURVEY_STATUS_LIST = 'surveyStatusList'
}
